import cloneDeep from 'lodash/cloneDeep';
import { createActions } from 'redux-actions';
import { v4 } from 'uuid';
import type { QnAStateType } from '../reducers/index';
export type SelectAnswerPayload = {
  qnaState: QnAStateType;
  questionId: string;
  question: string;
  answer: string;
  type: string;
  limit: number;
};
export type RemoveAnswerPayload = {
  qnaState: QnAStateType;
  questionId: string;
  answer: string;
};
export type UpdateAnswersPayload = {
  questionId: string;
  question: string;
  answers: {
    [key: string]: any;
  };
};
export type UpdateNotePayload = {
  questionId: string;
  note: string;
};
export type Payload = SelectAnswerPayload | RemoveAnswerPayload | UpdateAnswersPayload | UpdateNotePayload;
export type Action = {
  type: string;
  payload: Payload;
};
const createQuestion = () => {
  return cloneDeep({
    id: v4(),
    question: '',
    type: 'select',
    limit: 1,
    tags: [],
    answers: [],
    followUps: []
  });
};
export default createActions({
  removeQuestion: questionId => ({
    questionId
  }),
  addQuestion: (questionId, newQuestion = createQuestion()) => ({
    questionId,
    newQuestion
  }),
  addConditionalQuestion: (questionId, followUpIdx, newQuestion = createQuestion()) => ({
    questionId,
    followUpIdx,
    newQuestion
  }),
  updateQuestion: question => ({
    question
  }),
  selectAnswer: (payload: SelectAnswerPayload) => payload,
  removeAnswer: (payload: RemoveAnswerPayload) => payload,
  updateAnswers: (payload: UpdateAnswersPayload) => payload,
  setModal: (type, meta) => ({
    type,
    meta
  }),
  updateNote: (payload: UpdateNotePayload) => payload
});